import { render, staticRenderFns } from "./FieldSortingControls.vue?vue&type=template&id=10c972ce&scoped=true&lang=html&"
import script from "./FieldSortingControls.vue?vue&type=script&lang=js&"
export * from "./FieldSortingControls.vue?vue&type=script&lang=js&"
import style0 from "./FieldSortingControls.vue?vue&type=style&index=0&id=10c972ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c972ce",
  null
  
)

export default component.exports